export const VIDEO_TUTORIAL_URL = 'https://www.youtube.com/embed/vKdcoKPoxTM';

export const MASTERCLASS_URL = 'https://masterclass.chatbeat.com/course?utm_source=chatbeat-app';

// sessionStorage keys for the admin "log in as user" flow (set in AdminUsersEditPage,
// rendered by ImpersonationBanner, checked by Intercom event tracking).
export const IMPERSONATION_ORIGINAL_TOKEN_KEY = 'impersonation_original_token';
export const IMPERSONATION_TARGET_ID_KEY = 'impersonation_target_id';

/** The address every "contact us" on a blocking screen points to. */
export const SUPPORT_EMAIL = 'help@chatbeat.com';

export const TRIAL_ADVISOR = {
  name: 'Sylwia',
  email: 'sylwia@chatbeat.com',
  calendly: 'https://calendly.com/sylwia_chatbeat/intro',
} as const;

export const PAID_ADVISOR = {
  name: 'Ula',
  email: 'ula@chatbeat.com',
  calendly: 'https://calendly.com/ula-chatbeat',
} as const;


export const B24_ADVISOR = {
  name: 'Karol',
  email: 'karol.switala@brand24.pl',
  calendly: 'https://calendly.com/karol-switala-brand24/prezentacja-chatbeat',
} as const;